import { type RefObject, useCallback, useRef, useState } from 'react'

type SaveGuard = {
  isSaving: boolean
  // Read synchronously, so a second click in the same tick is still refused.
  isSavingRef: RefObject<boolean>
  run: (task: () => Promise<void>) => Promise<void>
}

// One save at a time: the complaints PUT runs before the booking mutation reports loading.
export const useSaveGuard = (): SaveGuard => {
  const isSavingRef = useRef(false)
  const [isSaving, setIsSaving] = useState(false)

  const run = useCallback(async (task: () => Promise<void>) => {
    if (isSavingRef.current) return
    isSavingRef.current = true
    setIsSaving(true)
    try {
      await task()
    } finally {
      isSavingRef.current = false
      setIsSaving(false)
    }
  }, [])

  return { isSaving, isSavingRef, run }
}
